/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from './firebase';
// @ts-ignore - Importing from HRM services
import apiService from 'services/apiService';

interface StandUpBridgeProps {
    children: React.ReactNode;
}

const StandUpBridge: React.FC<StandUpBridgeProps> = ({ children }) => {
    const [firebaseReady, setFirebaseReady] = useState(false);
    const [initializing, setInitializing] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (firebaseReady || initializing) return;
        
        const initFirebase = async () => {
            setInitializing(true);
            console.log("StandUp Bridge: Starting initialization...");
            try {
                // 1. Get custom token from our backend
                const response = await apiService.get('api/firebase/custom-token');
                const { token } = response.data;
                console.log("StandUp Bridge: Successfully fetched custom token from backend");

                // 2. Sign in to Firebase
                const userCredential = await signInWithCustomToken(auth, token);
                console.log("StandUp Bridge: Signed in to Firebase successfully as:", userCredential.user.email);
                setFirebaseReady(true);
            } catch (err: any) {
                console.error("StandUp Bridge Error:", err);
                if (err.response) {
                    console.error("Backend Error Detail:", err.response.data);
                }
                setError("Could not connect to StandUp services.");
            }
        };

        initFirebase();
    }, []);

    if (error) {
        return <div className="p-4 text-red-500 bg-red-100 rounded-md">{error}</div>;
    }

    if (!firebaseReady) {
        return (
            <div className="flex items-center justify-center p-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-3 text-gray-500 font-medium">Synchronizing with StandUp...</span>
            </div>
        );
    }

    return <>{children}</>;
};

export default StandUpBridge;
